import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '../icon';
import { BottomSheetButtonIcon } from './styles/bottom-sheet-button-icon.styled';
export const BottomSheetNavButton = ({ onClick, dataTest = 'bottom-sheet-nav-button', }) => (_jsx(BottomSheetButtonIcon, { color: "tertiary", role: "button", onClick: (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick();
        }
    }, dataTest: dataTest, children: _jsx(Icon, { variant: "chevron-left" }) }));
